//#region src/globals.ts
var ENV = [
	"development",
	"localdev",
	"qa",
	"test",
	"staging",
	"production"
];
var isEnv = (value) => {
	return ENV.includes(value);
};
var domains = {
	production: "https://www.opendoor.com",
	staging: "https://demo.simplersell.com",
	qa: "https://demo.simplersell.com",
	development: "http://localhost:3011",
	localdev: "http://localhost:3011",
	test: "https://www.opendoor.com"
};
var getDomain = (env) => {
	if (!isEnv(env) || !domains[env]) throw new Error(`DEVELOPER ERROR: Invalid DOMAIN, env ${env} is not in ${ENV.join(",")}`);
	return domains[env];
};
var getRedirectUrl = () => encodeURIComponent(window.location.href);
var EMAIL_PREFILL_QUERY_PARAM = "emailPrefill";
/**
* Returns the URL for normal login. If successfully authenticated, the user will be redirected to the current location.
*
* @param env - Environment to use to get the correct domain
* @param emailPrefill  - [Optional] Email to use to prefill the log-in/sign-up form
*/
var getLoginUrlWithRedirect = (env, emailPrefill) => {
	const emailPrefillParam = emailPrefill ? `&${EMAIL_PREFILL_QUERY_PARAM}=${emailPrefill}` : "";
	return `${getDomain(env)}/login?redirectTo=${getRedirectUrl()}${emailPrefillParam}`;
};
var LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM = "access_token";
/**
* @description
* Returns the URL for login lite. If successfully authenticated, the user will be redirected to the current location.
*
* Domain: `opendoor.com/token`
* Query params:
*    1. `access_token=<TOKEN>`
*    2. `redirect_url=<ENCODED_CURRENT_URL>`
*/
var getLoginLiteUrlWithRedirect = (env, accessToken) => {
	return `${getDomain(env)}/token?${LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM}=${accessToken}&redirect_url=${getRedirectUrl()}`;
};
//#endregion
export { EMAIL_PREFILL_QUERY_PARAM, ENV, LOGIN_LITE_ACCESS_TOKEN_QUERY_PARAM, getDomain, getLoginLiteUrlWithRedirect, getLoginUrlWithRedirect, isEnv };

